import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import { ItemOption } from '@models/item';
import OrderContext from '@providers/OrderProvider/OrderContext';
import useOptionControl from '@store/item/hooks/useOptionControl';
import { JSX, useContext } from 'react';

import {
  DisposableCupDefault,
  DisposableCupSelected,
  HotDefault,
  HotSelected,
  IceDefault,
  IceSelected,
  ReusableCupDefault,
  ReusableCupSelected,
  TumblerDefault,
  TumblerSelected,
} from './icons';
import styles from './styles.module.scss';

interface Props {
    option: ItemOption;
    optionGroupId: string;
    itemId: string;
}

type AvailableOptionName = 'HOT' | 'ICE' | '머그컵' | '일회용컵' | '텀블러';

interface OptionIcon {
    DefaultIcon: () => JSX.Element;
    SelectedIcon: () => JSX.Element;
}

const optionsIcons : Record<AvailableOptionName, OptionIcon> = {
  HOT: {
    DefaultIcon: HotDefault,
    SelectedIcon: HotSelected,
  },
  ICE: {
    DefaultIcon: IceDefault,
    SelectedIcon: IceSelected,
  },
  머그컵: {
    DefaultIcon: ReusableCupDefault,
    SelectedIcon: ReusableCupSelected,
  },
  일회용컵: {
    DefaultIcon: DisposableCupDefault,
    SelectedIcon: DisposableCupSelected,
  },
  텀블러: {
    DefaultIcon: TumblerDefault,
    SelectedIcon: TumblerSelected,
  },
};

function OptionItem({
  option, optionGroupId, itemId,
}:Props) {
  const {
    optionId, salePrice, name, isChangeable,
  } = option;
  // const { isOptionSelected, selectOption } = useContext(OrderContext);
  const { isOptionSelected, selectOption } = useOptionControl({ itemId });
  const isSelected = isOptionSelected({ optionId, optionGroupId });
  const optionName = name as AvailableOptionName;
  const { DefaultIcon, SelectedIcon } = optionsIcons[optionName];
  return (
        <Column spacing={8}
                onClick={() => {
                  if (isChangeable) {
                    selectOption({ option, optionGroupId, amount: 1 });
                  }
                }}
                className={(!isChangeable) ? styles.disabled : ''}
                align='center' >
            {isSelected ? (
                <SelectedIcon/>
            ) : (
                <DefaultIcon/>
            )}
            <Text className={styles.name}>
                {name}
                {salePrice !== 0 && (
                    <Text color={colors.gray6} as='span'><br/>
                        +{salePrice.toLocaleString()}원
                    </Text>
                )}
            </Text>
        </Column>
  );
}

export default OptionItem;
